export function capitalizeFirst(str) {
  if (str) {
    const [first, ...rest] = str.split('');
    str = first.toUpperCase() + rest.join('');
  }

  return str;
}
